import React from 'react';
import {Stack} from "@mui/material";
import {AgGridReact} from "ag-grid-react";

export interface IAgGridCustomToolbarInfoParams<TData extends any = any> {
    gridRef?: React.RefObject<AgGridReact<TData>> | undefined,
}

export interface IAgGridCustomToolbarActionsParams<TData extends any = any> {
    gridRef?: React.RefObject<AgGridReact<TData>> | undefined,
}

export interface AgGridCustomToolbarProps<TData extends any = any> {
    gridRef?: React.RefObject<AgGridReact<TData>>,
    renderInfo?: (params: IAgGridCustomToolbarInfoParams) => React.ReactElement
    renderActions?: (params: IAgGridCustomToolbarActionsParams) => React.ReactElement
}

const AgGridCustomToolbar = (props: AgGridCustomToolbarProps) => {
    return (
        <Stack direction="row" alignItems="center" justifyContent="space-between"
               sx={{padding: '8px'}}>
            <Stack direction="row" alignItems="center">
                {props.renderInfo && props.renderInfo({gridRef: props.gridRef})}
            </Stack>
            <Stack direction="row" alignItems="center" columnGap={2}>
                {props.renderActions && props.renderActions({gridRef: props.gridRef})}
            </Stack>
        </Stack>
    );
};

export default AgGridCustomToolbar;